var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PanelBox',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"title":((_vm.isEdit ? '编辑' : '新增') + "设备")}},[_c('a-form',{staticClass:"clearfix",attrs:{"form":_vm.form},on:{"submit":_vm.handleSubmit}},[_c('a-row',{staticClass:"pl20 pr20",attrs:{"gutter":24}},[_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备名称"}},[(_vm.isShiDaill)?_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: '设备名称为空'
                  }
                ]
              }
            ]),expression:"[\n              'name',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '设备名称为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"show-search":"","allowClear":"","placeholder":"请选择设备名称","options":_vm.deviceOptions},on:{"inputKeydown":_vm.changeDeviceName,"change":_vm.selectDeviceName}}):_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: '设备名称为空'
                  }
                ],
                getValueFromEvent: function (event) { return event.target.value.trim(); }
              }
            ]),expression:"[\n              'name',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '设备名称为空'\n                  }\n                ],\n                getValueFromEvent: event => event.target.value.trim()\n              }\n            ]"}],staticClass:"w80",attrs:{"placeholder":"请输入设备名称"}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"所属车场"}},[_c('ParkingLotSearch',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'parkId',
              {
                rules: [{ required: true, message: '车场不能为空' }]
              }
            ]),expression:"[\n              'parkId',\n              {\n                rules: [{ required: true, message: '车场不能为空' }]\n              }\n            ]"}],staticClass:"w80",attrs:{"disabled":_vm.isParkDisabled}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备类型"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'type',
              {
                rules: [
                  {
                    required: true,
                    message: '设备类型为空'
                  }
                ]
              }
            ]),expression:"[\n              'type',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '设备类型为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"placeholder":"请选择设备类型","options":_vm.typeOptions},on:{"change":_vm.getType}})],1)],1),_c('p'),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备品牌"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'brand',
              {
                rules: [
                  {
                    required: true,
                    message: '设备品牌为空'
                  }
                ]
              }
            ]),expression:"[\n              'brand',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '设备品牌为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"placeholder":"请选择设备品牌","options":_vm.typeBrandOptions},on:{"change":_vm.getBrand}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备型号"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'mode',
              {
                rules: [
                  {
                    required: true,
                    message: '设备型号为空'
                  }
                ]
              }
            ]),expression:"[\n              'mode',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '设备型号为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"options":_vm.brandModeOptions,"placeholder":"请选择设备型号"}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备连接方式"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'connectType',
              {
                rules: [
                  {
                    required: true,
                    message: '设备连接方式为空'
                  }
                ]
              }
            ]),expression:"[\n              'connectType',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '设备连接方式为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"placeholder":"请选择设备连接方式","options":_vm.deviceConnectionOptions},on:{"change":_vm.getConnectType}})],1)],1),_c('p'),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备IP"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'ip',
              {
                rules: [
                  {
                    required: false,
                    message: '设备IP为空'
                  }
                ],
                getValueFromEvent: function (event) { return event.target.value.trim(); }
              }
            ]),expression:"[\n              'ip',\n              {\n                rules: [\n                  {\n                    required: false,\n                    message: '设备IP为空'\n                  }\n                ],\n                getValueFromEvent: event => event.target.value.trim()\n              }\n            ]"}],staticClass:"w80",attrs:{"placeholder":"请输入设备IP"}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备端口"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'port',
              {
                rules: [
                  {
                    required: false,
                    message: '设备端口为空'
                  }
                ],
                getValueFromEvent: function (event) { return event.target.value.trim(); }
              }
            ]),expression:"[\n              'port',\n              {\n                rules: [\n                  {\n                    required: false,\n                    message: '设备端口为空'\n                  }\n                ],\n                getValueFromEvent: event => event.target.value.trim()\n              }\n            ]"}],staticClass:"w80",attrs:{"placeholder":"请输入设备端口"}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备连接源"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'connectSource',
              {
                rules: [
                  {
                    required: false,
                    message: '设备连接源为空'
                  }
                ]
              }
            ]),expression:"[\n              'connectSource',\n              {\n                rules: [\n                  {\n                    required: false,\n                    message: '设备连接源为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"options":_vm.deviceConnectOptions,"allowClear":"","placeholder":"请选择设备连接源"}})],1)],1),_c('p'),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"驱动版本号"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'deviceVersion',
              {
                rules: [
                  {
                    required: true,
                    message: '驱动版本号为空'
                  }
                ]
              }
            ]),expression:"[\n              'deviceVersion',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '驱动版本号为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"options":_vm.brandModeOptions,"placeholder":"请选择驱动版本号"}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"是否支持万能语音"}},[_c('a-radio-group',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'isSupportTts',
              {
                initialValue: '01',
                rules: [
                  {
                    required: true,
                    message: '万能语音为空'
                  }
                ]
              }
            ]),expression:"[\n              'isSupportTts',\n              {\n                initialValue: '01',\n                rules: [\n                  {\n                    required: true,\n                    message: '万能语音为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"options":_vm.isSupportTtsTypeOptions}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备优先级"}},[_c('a-input-number',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'priority',
              {
                initialValue: 0,
                rules: [
                  {
                    required: true,
                    message: '设备优先级为空'
                  }
                ]
              }
            ]),expression:"[\n              'priority',\n              {\n                initialValue: 0,\n                rules: [\n                  {\n                    required: true,\n                    message: '设备优先级为空'\n                  }\n                ]\n              }\n            ]"}],staticClass:"w80",attrs:{"min":0,"max":1}})],1)],1),_c('a-col',{attrs:{"span":8}},[_c('a-form-item',{attrs:{"label":"设备编号"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'deviceCode',
              {
                rules: [
                  {
                    required: false,
                    message: '设备编号为空'
                  },
                  { max: 64, message: '设备编号最多输入64个字符' }
                ],
                getValueFromEvent: function (event) { return event.target.value.trim(); }
              }
            ]),expression:"[\n              'deviceCode',\n              {\n                rules: [\n                  {\n                    required: false,\n                    message: '设备编号为空'\n                  },\n                  { max: 64, message: '设备编号最多输入64个字符' }\n                ],\n                getValueFromEvent: event => event.target.value.trim()\n              }\n            ]"}],staticClass:"w80",attrs:{"placeholder":"请输入设备编号","disabled":_vm.isShiDaill}})],1)],1)],1),_c('a-form-item',{staticClass:"submitBtns"},[_c('a-button',{on:{"click":_vm.handleCancel}},[_vm._v("取消")]),_c('a-button',{staticClass:"ml80",attrs:{"type":"primary","html-type":"submit","loading":_vm.spining}},[_vm._v("保存")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }